<pp-modal [ppThin]="true">
  <ng-container heading>
    {{ 'export' | ppTranslate }}
  </ng-container>

  <ng-container body>
    <h5 class="dashletExport__header">
      {{ 'page_layout' | ppTranslate }}
    </h5>

    <div class="siteOptionsExportModal__radio-buttons">
      @for (format of exportFormats; track format) {
        <pp-radio
          [ppChecked]="format.value === selectedFormat"
          (ppOnValueChange)="toggleFormat(format)"
          ppStyle="blue"
          >
          <label class="control-custom control-custom--radio">
            {{ format.label }}
          </label>
        </pp-radio>
      }
    </div>

    <h5 class="dashletExport__header">
      {{ 'select_dashlets_to_export' | ppTranslate }}

      <i
        ppTooltip
        class="fa fa-info-circle dashletExport__header-info"
        aria-hidden="true"
        [ppMobileTooltip]="true"
        [ppTitle]="'activities_cannot_be_exported' | ppTranslate"
      ></i>
    </h5>

    @if (simpleDashlets.length) {
      <h6 class="dashletExport__header">
        {{ 'simple_dashlets' | ppTranslate }}
      </h6>
    }

    <div class="dashboardExport__dashlet-list">
      @for (dashlet of simpleDashlets; track dashlet) {
        <div class="dashboardExport__dashlet">
          <pp-checkbox
            [ppChecked]="dashlet.selected"
            (ppOnValueChange)="toggleExportDashlet(dashlet)"
            >
            <label>
              {{ dashletNames[dashlet.name] | ppTranslate }} (<span
              class="dashboardExport__dashlet--bold"
              >
              {{ dashlet.accountName }} - {{ dashlet.workspaceName }}</span
              >)
            </label>
          </pp-checkbox>
        </div>
      }
    </div>

    @if (advancedDashlets.length) {
      <h6 class="dashletExport__header">
        {{ 'advanced_dashlets' | ppTranslate }}
      </h6>
    }

    <div class="dashboardExport__dashlet-list">
      @for (dashlet of advancedDashlets; track dashlet) {
        <div class="dashboardExport__dashlet">
          <pp-checkbox
            [ppChecked]="dashlet.selected"
            (ppOnValueChange)="toggleExportDashlet(dashlet)"
            >
            <label>
              {{ dashletNames[dashlet.name] | ppTranslate }} (<span
              class="dashboardExport__dashlet--bold"
              >
              {{ dashlet.accountName }} - {{ dashlet.workspaceName }}</span
              >)
            </label>
          </pp-checkbox>
        </div>
      }
    </div>

    <div #exportZone></div>
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'export' | ppTranslate"
      [ppProcess]="processing"
      (ppCancel)="hideModal()"
      (ppConfirm)="export()"
      [ppDisabled]="!anyDashletSelected"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
